import React from 'react';
import imgImage36 from '../../assets/sections/8ac0c64c7c715f2c436796d24ce7482e11faaf8b.png';
import imgImage37 from '../../assets/sections/09d9396a301f711db95e5a1d92de397c9cc6c1df.png';
import imgImage65 from '../../assets/sections/94cc8c8a99503febba77ef43add7ac4866427627.png';
import imgEllipse2 from '../../assets/sections/ebce200a498a754bac596c92ec061161b9c4a560.svg';
import imgImage35Vectorized from '../../assets/sections/01fa17e658c350e09aaf1883763874e669a9ea7d.svg';
import imgGroup17 from '../../assets/sections/4b092af9b6cfa5000fdd07da2ffe4c4499f08f44.svg';


export default function CompanyParticipants() {
  return (
    <div className="bg-[#012e2a] relative w-[1921px] h-[1080px]" data-node-id="233:445">
      <div className="absolute h-[565px] left-[-727px] top-[587px] w-[1097px]" data-node-id="233:455">
        <div className="absolute w-[500px] h-[500px] left-[1400px] top-[-150px]">
          <img alt="" className="block max-w-none size-full" src={imgEllipse2} />
        </div>
      </div>
      <p className="absolute font-['Alexandria',sans-serif] font-bold leading-[normal] left-[calc(50%-450.5px)] text-[#e9fffa] text-[56px] top-[249px] uppercase whitespace-nowrap" data-node-id="233:463">
        Doanh nghiệp đồng hành
      </p>
      <div className="absolute h-0 left-[784px] top-[80px] w-[356px]" data-node-id="233:556">
        <div className="absolute inset-[-48px_-13.48%]">
          <img alt="" className="block max-w-none size-full" src={imgGroup17} />
        </div>
      </div>
      {/* Company logo cards - updated layout from Figma node 2003:445 */}
      <div className="absolute contents left-[546px] top-[471px]" data-node-id="2003:445">
        {/* TopCV logo */}
        <div className="absolute content-stretch flex flex-col h-[137.435px] items-start left-[546px] px-[31.543px] py-[27.036px] rounded-[16px] shadow-[0px_45.061px_78.105px_0px_rgba(0,0,0,0.05)] top-[471px] w-[349.221px]" data-node-id="2003:446">
          <div aria-hidden="true" className="absolute bg-white inset-0 pointer-events-none rounded-[16px]" />
          <div className="h-[83.362px] relative shrink-0 w-[286.136px]" data-name="image 35 [Vectorized]" data-node-id="2003:447">
            <img alt="" className="absolute block max-w-none size-full" src={imgImage35Vectorized} />
          </div>
          <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_75.101px_0px_rgba(0,177,79,0.1)]" />
        </div>
        {/* Company logo image36 top-right */}
        <div className="absolute content-stretch flex flex-col h-[137.435px] items-center justify-center left-[991.35px] pointer-events-none px-[31.543px] py-[27.036px] rounded-[16px] shadow-[0px_45.061px_78.105px_0px_rgba(0,0,0,0.05)] top-[471px] w-[349.221px]" data-node-id="2003:461">
          <div aria-hidden="true" className="absolute bg-white inset-0 rounded-[16px]" />
          <div className="aspect-[740/448] flex-[1_0_0] min-h-px min-w-px relative " data-name="image 36" data-node-id="2003:462">
            <img alt="" className="absolute inset-0 max-w-none object-cover size-full" src={imgImage36} />
            <div className="absolute inset-0 rounded-[inherit] shadow-[inset_0px_6.759px_8.036px_0px_rgba(255,255,255,0.25)]" />
          </div>
          <div className="absolute inset-0 rounded-[inherit] shadow-[inset_0px_0px_75.101px_0px_rgba(0,177,79,0.1)]" />
        </div>
        {/* Company logo image37 bottom-right */}
        <div className="absolute content-stretch flex flex-col h-[137.435px] items-center justify-center left-[991.46px] px-[31.543px] py-[27.036px] rounded-[16px] shadow-[0px_45.061px_78.105px_0px_rgba(0,0,0,0.05)] top-[687px] w-[349.221px]" data-node-id="2003:463">
          <div aria-hidden="true" className="absolute bg-white inset-0 pointer-events-none rounded-[16px]" />
          <div className="h-[63.085px] relative shrink-0 w-[280.128px]" data-name="image 37" data-node-id="2003:464">
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
              <img alt="" className="absolute h-[444.05%] left-0 max-w-none top-[-172.62%] w-full" src={imgImage37} />
            </div>
          </div>
          <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_75.101px_0px_rgba(0,177,79,0.1)]" />
        </div>
        {/* Company logo image65 bottom-left */}
        <div className="absolute content-stretch flex flex-col h-[137.435px] items-center justify-center left-[546px] px-[31.543px] py-[27.036px] rounded-[16px] shadow-[0px_45.061px_78.105px_0px_rgba(0,0,0,0.05)] top-[687px] w-[349.221px]" data-node-id="2003:466">
          <div aria-hidden="true" className="absolute bg-white inset-0 pointer-events-none rounded-[16px]" />
          <div className="h-[59px] relative shrink-0 w-[245px]" data-name="image 65" data-node-id="2003:467">
            <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImage65} />
          </div>
          <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_75.101px_0px_rgba(0,177,79,0.1)]" />
        </div>
      </div>
    </div>
  );
}
